import { StreamChat } from 'stream-chat';

import { getConfig } from './appConfig';

const { streamChatAppId, streamChatDisable } = getConfig();

export const StreamClient = !streamChatDisable
  ? StreamChat.getInstance(streamChatAppId)
  : null;
